import React from "react";
import EventPage from "../components/EventPage";

const EventPageApp = (props) => <EventPage {...props} />;

export default EventPageApp;
